import { FundingRequests } from '@factorin/domain';

import { withUrl, list } from '../rest';


const fundingrequestsPart = withUrl('fundingrequests');
const fundingrequestsrawsPart = withUrl('fundingrequestsraws');

export const fundingrequests = {
    ...list<FundingRequests.FundingRequest>(fundingrequestsPart()),
};

export const fundingrequestsraws = {
    ...list<FundingRequests.FundingRequest>(fundingrequestsrawsPart()),
};
